module.exports = __webpack_public_path__ + "themes/mf/font/SignPainter-HouseScript.woff";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/SignPainter-HouseScript.woff
// module id = 136
// module chunks = 3